import React, { useState } from 'react';
import Calendar from './Calendar';
import AppointmentList from './AppointmentList';

const CalendarView = ({ appointments = [], loading = false, onMonthChange, onEditAppointment, onDeleteAppointment }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="space-y-6 min-w-0 overflow-x-hidden max-w-full">
      {/* Calendário */}
      <div className="relative">
        {loading && (
          <div className="absolute top-0 right-0 z-10 p-2">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-600"></div>
          </div>
        )}
        <Calendar 
          selectedDate={selectedDate}
          onDateSelect={handleDateSelect}
          appointments={appointments}
          onMonthChange={onMonthChange}
        />
      </div>
      
      {/* Lista de agendamentos */}
      <AppointmentList 
        appointments={appointments}
        selectedDate={selectedDate}
        onEditAppointment={onEditAppointment}
        onDeleteAppointment={onDeleteAppointment}
      />
    </div>
  );
};

export default CalendarView;
